import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/sections/service-page";
import { pageData } from "@/lib/service-page-data";
const data = pageData["ai-automation"];
export const Route = createFileRoute("/services/ai-automation")({
  component: () => <ServicePage data={data} />,
  head: () => ({
    meta: [
      { title: `${data.title} — CoderLity` },
      { name: "description", content: data.sub },
      { property: "og:title", content: `${data.title} — CoderLity` },
      { property: "og:description", content: data.sub },
      { property: "og:url", content: "/services/ai-automation" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/services/ai-automation" }],
  }),
});
